/**
 * WPS Data Service
 * 
 * Common data handling utilities for WPS transaction components
 * Handles header and detail data submission across General, WeldingProcedure, and WeldingProcedureSpec
 */

import { Action, MessageTypes, Status } from "../../utility/common/constants/CommonConstants";
import { AddNewGroove } from "../../../Services/wps_groove-services";
import { AddNewDetail } from "../../../Services/wps_details-service";

/**
 * Process API response and return appropriate result type
 */
export const processApiResponse = (response) => {
  if (response?.data?.message === "Validate") {
    return MessageTypes.SpecialCharacters;
  }
  return MessageTypes.Success || "success";
};

/**
 * Handle status changes for approved/rejected items
 */
export const handleStatusChange = (headerObj, location,action=Action.ActionEdit,approvalStatus="") => {
  
  //If Approved
  if (
    headerObj.WPSH_Approval_Status !== Status.StatusTempSaved &&
    headerObj.WPSH_Approval_Status !== undefined
  ) {
    headerObj.WPSH_Status = headerObj.WPSH_Approval_Status;
}//if approved and changes made
  else if (headerObj.WPSH_Status === Status.StatusApproved || headerObj.WPSH_Status === Status.StatusRejected) {
    if (headerObj.WPSH_Status === Status.StatusApproved) {
      headerObj.WPS_Change_No = location.state?.WPS_Change_No;
    //  AddNewCount(headerObj);

    }
    headerObj.WPSH_Status = Status.StatusPending;
  }
  else{
  if(approvalStatus != "")
    headerObj.WPSH_Status = approvalStatus;
  
  }
 
  //if action is copy
  if (action === Action.ActionCopy) {
    headerObj.WPS_Change_No = "0";
    headerObj.WPSH_Status = Status.StatusTempSaved;
  }
};

/**
 * Add header data with error handling
 */
export const addHeaderData = async (headerObj) => {
  try {
    const response = await AddNewGroove(headerObj);
    return processApiResponse(response);
  } catch (error) {
    console.error("Error adding header:", error);
    return false;
  }
};

/**
 * Add detail data with parallel processing
 */
export const addDetailData = async (detaildata) => {
  if (!detaildata || detaildata.length === 0) {
    return [];
  }

  const detailPromises = detaildata.map(async (item) => {
    try {
      const response = await AddNewDetail(item);
      return processApiResponse(response);
    } catch (error) {
      console.error("Error adding detail:", error);
      return false;
    }
  });

  return Promise.all(detailPromises);
};

/**
 * Determine final result based on header and detail results
 */
export const getFinalResult = (headerResult, detailResults = []) => {
  const hasFailures = detailResults.some(result => result === false) || headerResult === false;
  const hasValidationErrors = detailResults.some(result => result === MessageTypes.SpecialCharacters) || headerResult === MessageTypes.SpecialCharacters;

  if (hasFailures) {
    return false;
  }
  if (hasValidationErrors) {
    return MessageTypes.SpecialCharacters;
  }
  return true;
};

/**
 * Common handleAdd function for all WPS pages
 * @param {Object} headerObj - Header object to save
 * @param {Array} detaildata - Detail data array to save (optional for some pages)
 * @param {Object} location - React router location object
 * @param {string} savetype - Save type (optional, for future use)
 * @returns {Promise<string|boolean>} Result of the operation
 */
export const handleWPSAdd = async (headerObj, location, detaildata = [], savetype = "") => {
  // Handle status changes
 
  // Process header and details in parallel (if details exist)
  const promises = [addHeaderData(headerObj)];
  
  if (detaildata && detaildata.length > 0) {
    promises.push(addDetailData(detaildata));
  }
  
  const results = await Promise.all(promises);
  const headerResult = results[0];
  const detailResults = results[1] || [];
  
  return getFinalResult(headerResult, detailResults);
};

/**
 * Specialized handleAdd for pages with only header data (like General)
 */
export const handleHeaderOnlyAdd = async (headerObj, location, savetype = "") => {
  return handleWPSAdd(headerObj, location, [], savetype);
};

/**
 * Specialized handleAdd for pages with header and detail data (like WeldingProcedure)
 */
export const handleHeaderDetailAdd = async (headerObj, detaildata, location, savetype = "") => {
  const filteredDetailData = detaildata.filter((item) => item.WPSD_Process !== "");
  return handleWPSAdd(headerObj, location, filteredDetailData, savetype);
};